import { Cancel } from "@mui/icons-material";
import { Timestamp, doc, setDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import db from "./Backend";


let request;
let db2;
let version = 1;

export const initDB = () => {
  return new Promise((resolve, reject) => {
    request = indexedDB.open('myDB', version);

    request.onsuccess = (event) => {
        try{
            // db2 = request.result;
            db2 = event.target.result;
            version = db2.version;
            resolve(true);
        }catch(err){
            console.log(err);
        }
        };
        request.onupgradeneeded = (event) => {
            // db2 = request.result;
            db2 = event.target.result;
            if (!db2.objectStoreNames.contains('anouncestore')) {
                db2.createObjectStore('anouncestore', { keyPath: 'id' });
              }   
         }
  
    request.onerror = (event) => {
      reject(`Error opening IndexedDB: ${event.target.error}`);
    };
  });
};


export const addData = (data) => {
    return new Promise((resolve, reject) => {
      const transaction = db2.transaction(['anouncestore'], 'readwrite');
      const objectStore = transaction.objectStore('anouncestore');
      const request = objectStore.put(data);
  
      request.onsuccess = (event) => {
        resolve(true);
      };
  
      request.onerror = (event) => {
        reject(`Error adding data: ${event.target.error}`);
      };
    });
  };
  
  export const getData = (id) => {
    return new Promise((resolve, reject) => {
      const transaction = db2.transaction(['anouncestore']);
      const objectStore = transaction.objectStore('anouncestore');
      const request = objectStore.get(id);
  
      request.onsuccess = (event) => {
        resolve(request.result);
      };
  
      request.onerror = (event) => {
        reject(`Error getting user: ${event.target.error}`); 
      };
    });
  };
  


const Createanouncement = () => {
    const [field1,setField1]=useState("");
    const [field2,setField2]=useState("");
    const [field3,setField3]=useState("");
    const [field4,setField4]=useState("");
    const [field5,setField5]=useState("");
    const [field6,setField6]=useState("");

    const [inputValue1,setInputValue1]=useState("");
    const [inputValue2,setInputValue2]=useState("");
    const [inputValue3,setInputValue3]=useState("");
    const [inputValue4,setInputValue4]=useState("");
    const [inputValue5,setInputValue5]=useState("");
    const [inputValue6,setInputValue6]=useState("");

    const[showInput3,setShowInput3]=useState(false);
    const[showInput4,setShowInput4]=useState(false);
    const[showInput5,setShowInput5]=useState(false);
    const[showInput6,setShowInput6]=useState(false);
    const[generalAnounce,setGeneralanounce]=useState("");
    const[success,setSuccessMessage]=useState(false);
    const[closeAddinputs,setCloseAddinputs]=useState(false);
    const[currentIndex,setCurrentindex]=useState(2);
    const rowspan = 20;
    const now = Timestamp.now();
    const anouncementDate = new Date(now?.toDate()).toUTCString();
    const timestamp = new Date().getTime();


    useEffect(()=>{
        if(currentIndex === 3){
            setShowInput3(true);
        }
        if(currentIndex === 4){
            setShowInput4(true);
        }
        if(currentIndex === 5){
            setShowInput5(true);
        }
        if(currentIndex === 6){
            setShowInput6(true);
            setCloseAddinputs(true);
        }
        if(currentIndex < 6){
            setCloseAddinputs(false);
        }
    },[currentIndex]);
   
    const showMoreInputs=()=>{
        const islastInputField = currentIndex === 6;
        const createnextfield = islastInputField?2:currentIndex+1;
        setCurrentindex(createnextfield);
    };

    const handleSubmitWeeklyPrograms=async(e)=>{
        e.preventDefault();
        try{
            await setDoc(doc(db,"programs","current"),{
                field1,
                field2,
                field3,
                field4,
                field5,
                field6,
                inputValue1,
                inputValue2,
                inputValue3,
                inputValue4,
                inputValue5,
                inputValue6,
                anouncement:generalAnounce,
                date:anouncementDate,
                timestamp
            });
         
            setSuccessMessage(true);
        }catch(err){
            console.log(err);
        }
    };

    const saveData=()=>{
       initDB().then(()=>{
        addData({
            id:"p2",
            field1,
            field2,
            field3,
            field4,
            field5,
            field6,
            inputValue1,
            inputValue2,
            inputValue3,
            inputValue4,
            inputValue5,
            inputValue6,
            anouncement:generalAnounce,
            date:anouncementDate,
        }).then(()=>{
            alert("saved data.")
        }); 
       }) 
    };

    useEffect(()=>{
        initDB().then(()=>{
            getData("p2").then((data)=>{
                if(data){
                    setField1(data.field1);
                    setField2(data.field2);
                    setField3(data.field3);
                    setField4(data.field4);
                    setField5(data.field5);
                    setField6(data.field6);
                    setInputValue1(data.inputValue1);
                    setInputValue2(data.inputValue2);
                    setInputValue3(data.inputValue3);
                    setInputValue4(data.inputValue4);
                    setInputValue5(data.inputValue6);
                    setInputValue6(data.inputValue6);
                    setGeneralanounce(data.anouncement);
                };
            }).catch((err)=>{
                console.log(err)
            })
        }).catch((err)=>{
            console.log(err)
        })
         
    },[]);


    return ( 
        <div className="createanouncement">
            <div className="weeklyacitivities">
            <h3>Weekly Programs</h3>
                <form onSubmit={handleSubmitWeeklyPrograms}>
                <div className="arrangeinputs">
                <input  id="fieldinput" type="text" placeholder="Field name" value={field1} onChange={(e)=>setField1(e.target.value)}/>
                <input  id="valueinput" type="text" placeholder="value" value={inputValue1} onChange={(e)=>setInputValue1(e.target.value)}/>
                </div>
                <div className="arrangeinputs">
                <input id="fieldinput" type="text" placeholder="Field name" value={field2} onChange={(e)=>setField2(e.target.value)}/>
                <input id="valueinput" type="text" placeholder="value" value={inputValue2} onChange={(e)=>setInputValue2(e.target.value)}/>
                </div>
                {showInput3&&
                    <div className="arrangeinputs">
                    <input id="fieldinput" type="text" placeholder="Field name" value={field3} onChange={(e)=>setField3(e.target.value)}/>
                    <input id="valueinput" type="text" placeholder="value" value={inputValue3} onChange={(e)=>setInputValue3(e.target.value)}/>
                    <div onClick={()=>{setShowInput3(false);setCurrentindex(currentIndex-1);}}><Cancel/></div>
                    </div>
                }
                {
                    showInput4&&
                    <div className="arrangeinputs">
                    <input id="fieldinput" type="text" placeholder="Field name" value={field4} onChange={(e)=>setField4(e.target.value)}/>
                    <input id="valueinput" type="text" placeholder="value" value={inputValue4} onChange={(e)=>setInputValue4(e.target.value)}/>
                    <div onClick={()=>{setShowInput4(false);setCurrentindex(currentIndex-1);}}><Cancel/></div>
                    </div>
                }
                {
                    showInput5&&
                    <div className="arrangeinputs">
                    <input id="fieldinput" type="text" placeholder="Field name" value={field5} onChange={(e)=>setField5(e.target.value)}/>
                    <input id="valueinput" type="text" placeholder="value" value={inputValue5} onChange={(e)=>setInputValue5(e.target.value)}/>
                    <div onClick={()=>{setShowInput5(false);setCurrentindex(currentIndex-1);}}><Cancel/></div>
                    </div>
                }
                {
                    showInput6&&
                    <div className="arrangeinputs">
                    <input id="fieldinput" type="text" placeholder="Field name" value={field6} onChange={(e)=>setField6(e.target.value)}/>
                    <input id="valueinput" type="text" placeholder="value" value={inputValue6} onChange={(e)=>setInputValue6(e.target.value)}/>
                    <div onClick={()=>{setShowInput6(false);setCurrentindex(currentIndex-1);}}><Cancel/></div>
                    </div>
                }
                </form>
                {
                    !closeAddinputs&&
                    <button onClick={showMoreInputs} style={{
                        cursor:"pointer",
                        backgroundColor:"transparent",
                        fontSize:"1rem",
                        fontWeight:"bold",
                        border:"none",
                        borderRadius:"10px",
                        padding:"10px",
                        color:"orangered"
                        }}>
                        Add more Fields
                    </button>
                }
            </div>

            <div className="generalanouncement">
                <h2>General Anouncement</h2>
                <textarea rows={rowspan} placeholder="General anouncement" value={generalAnounce} onChange={(e)=>setGeneralanounce(e.target.value)}/>
            </div>

            {

            success &&
            <div className="toast">
                <h2 style={{color:"white",fontWeight:"bold"}}>New announcement and weekdays program published </h2> 
                <button onClick={()=>setSuccessMessage(false)}><Cancel/></button>
            </div>
           }
            <div className="anouncebuttons flex-column2">
            <button onClick={handleSubmitWeeklyPrograms}>Publish</button>
            <button onClick={saveData}>save</button>
            </div>
           
            
        </div>
     );
}
 
export default Createanouncement;